import React from "react";
import { useL } from "@/lib/useL";
import { api } from "@/lib/api";
import { shareOrigin } from "@/lib/shareText";
import { PublicShareDialog } from "@/components/PublicShareDialog";

// Share a deck publicly: link + QR code to project in class.
export function DeckShare({ deck, open, onOpenChange, onChange }) {
  const L = useL();
  const onToggle = async (next) => {
    const { data } = await api.post(`/flashcards/${deck.id}/share`, { is_public: next });
    onChange(data.is_public);
  };
  return (
    <PublicShareDialog open={open} onOpenChange={onOpenChange} title={L("Partager les cartes avec la classe", "Share the cards with the class")}
      url={`${shareOrigin()}/c/${deck.id}`} isPublic={deck.is_public} onToggle={onToggle} testid="deck-share"
      hint={L("Projetez ce QR code : les élèves révisent les cartes sur leur téléphone.", "Project this QR code: pupils review the cards on their phone.")} />
  );
}

export default DeckShare;
